function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import styles from './ToogleSwitch.scss';

var ToogleSwitch = function ToogleSwitch(_ref) {
  var isOn = _ref.isOn,
      onToogle = _ref.onToogle,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onToogle,
    className: classnames(styles.ToogleSwitch, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(styles["switch"], _defineProperty({}, styles.isOn, isOn))
  }), children);
};

export default ToogleSwitch;